module.exports = __webpack_public_path__ + "img/MES10Indice6_cutout.c637c265.png";